import { put, takeLatest, call, select } from "redux-saga/effects";
import BaseRepositoryError from '../../repositories/base.errors';
import AuthRepository from '../../repositories/auth';
import { push } from 'connected-react-router';
import ROUTES from '../../../routes';
import { HandleSuccessRouteRedirect, handleAddUserAddressToDelivery } from './mixins';
import { getAuthSuccessRouter } from '../../selectors/routers';

import {
  FETCH_LOGIN_SAGA,
  FETCH_DATA_404,
  SET_DATA_ERROR_MSG,
  SET_USER_DATA,
} from '../../actions/actionTypes';

function* workerFetchSignIn(action) {
  try {
    const response = yield call(AuthRepository.login,{
      email: action.payload.email, password: action.payload.password,
    });
    yield put({ type: SET_USER_DATA, payload: response.user });
    let successRouter = yield select(getAuthSuccessRouter);
    if (response && response.user) {
      // check for
      successRouter = yield* handleAddUserAddressToDelivery(response.user.address, successRouter);
      if (!response.user.phone_verified) {
        yield put(push(
          { pathname: `${ROUTES.AUTH.path}/${ROUTES.AUTH.child.ADD_PHONE.path}`, state: { successRouter } }
        ));
      } else {
        yield* HandleSuccessRouteRedirect(successRouter);
      }
    } else {
      yield put ({ type: SET_DATA_ERROR_MSG, payload: 'please try again'});
    }
  } catch (e) {
    console.debug(e);
    if (e instanceof BaseRepositoryError) {
      yield put ({ type: SET_DATA_ERROR_MSG, payload: e.message });
      if (e.errorCode === 404) {
        yield put({ type: FETCH_DATA_404 });
      }
    }
  }
}

export default function* FetchSignInSaga() {
  yield takeLatest(FETCH_LOGIN_SAGA, workerFetchSignIn);
}
